import { render, staticRenderFns } from "./ServerAdministrationBlock.vue?vue&type=template&id=621a09b4&scoped=true&"
import script from "./ServerAdministrationBlock.vue?vue&type=script&lang=js&"
export * from "./ServerAdministrationBlock.vue?vue&type=script&lang=js&"
import style0 from "./ServerAdministrationBlock.vue?vue&type=style&index=0&id=621a09b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a09b4",
  null
  
)

component.options.__file = "ServerAdministrationBlock.vue"
export default component.exports